module.exports = __webpack_public_path__ + "media/images/pl01-365be0d6f784983d1e0566ae961e4f97.jpg";